export const SET_SELECTED_DEPARTMENT = "SET_SELECTED_DEPARTMENT"

export const setSelectedDepartment = selectedOption => (dispatch, getState) => {
    dispatch({ type: SET_SELECTED_DEPARTMENT, payload: selectedOption })
}
